<div *ngIf="showLine" class="{{siteId}} horizontal-separator"></div>
<div id="{{footerType}}"
    class="finder-syndicated-footer-wrapper"
    [class.has-line]="showLine"
    [@footerState]="stateName"
    (@footerState.done)="footerStateDone($event)">
    <finder-script-loader [src]="syndicatedFooterUrl"></finder-script-loader>
</div>
